import moment from "moment";

const before7DayDateIndianFormat = () => {
    const sevenDaysBeforeDate = new Date(new Date().setDate(new Date().getDate() - 7));
    return moment(sevenDaysBeforeDate).format("DD/MM/YYYY")
}

export default before7DayDateIndianFormat